import { Component, HostBinding, Input } from '@angular/core';
import { trigger, transition, useAnimation } from '@angular/animations';
import { slideInAnimation, slideOutAnimation } from '@app/shared/animations';

/**
 * RefreshComponent
 */
@Component({
  selector: 'ecp-refresh',
  templateUrl: './refresh.component.html',
  styleUrls: ['./refresh.component.scss'],
  animations: [
    trigger('visibilityChange', [
      transition(':enter', [
        useAnimation(slideInAnimation, {
          params: { timings: '400ms ease-out', from: '20%' },
        }),
      ]),
      transition(':leave', [
        useAnimation(slideOutAnimation, {
          params: { timings: '400ms ease-out', to: '20%' },
        }),
      ]),
    ]),
  ],
  standalone: false,
})
export class RefreshComponent {
  @HostBinding('class.nav') nav = true;

  @HostBinding('class.to-right')
  /**
   * toRight
   */
  @Input()
  toRight: boolean;
  /**
   * animation
   * @type {boolean}
   */
  @HostBinding('@visibilityChange') animation = true;
}
